import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { layoutDefaults } from '../../utils/layout-defaults';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function usePaymentCancelledModal() {
  const storage = useStorage();
  const { t } = useTranslation();
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage, includesTitleBottomMargin: true });

  function didOpen() {
    analyticsPageView('Payment Cancelled');
  }

  async function show() {
    const result = await swal.fire({
      title: t('payment-cancelled-modal.title'),
      icon: 'error',
      timer: layoutDefaults.modalTimer,
      didOpen,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
    });

    return result;
  }

  return {
    showPaymentCancelledModal: show,
  };
}

export { usePaymentCancelledModal };
